import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Role, UserRoleVM } from 'app/_models';
import { ToolsService } from 'app/_services/tools.service';

@Component({
    selector: 'app-edit-role-dialog',
    templateUrl: './edit-role-dialog.component.html',
    styleUrls: ['./edit-role-dialog.component.scss'],
})
export class EditRoleDialogComponent implements OnInit {
    title = 'User Editor';
    name: string;
    role: Role;
    roles: Role[];
    rolesNames: string[];
    roleEditorForm: FormGroup;
    creating: boolean;

    // Getters for form validation error messages
    get Role(): AbstractControl {
        return this.roleEditorForm.controls.RoleName;
    }

    constructor(
        private dialogRef: MatDialogRef<EditRoleDialogComponent>,
        private formBuilder: FormBuilder,
        private toolsService: ToolsService,
        @Inject(MAT_DIALOG_DATA) public data: { creating: boolean; role: Role; roles: Role[]; rolesNames: string[]; title: string }
    ) {
        this.title = data.title;
        this.creating = data.creating;
        this.role = data.role;
        this.roles = data.roles;
        this.rolesNames = data.rolesNames;
    }

    ngOnInit(): void {
        this.roleEditorForm = this.formBuilder.group({
            Name: [{ value: this.name, disabled: true }],
            RoleName: [this.role.roleName, [Validators.required, isRoleTaken(this.role.roleName, this.rolesNames)]],
        });
    }

    onNoClick(): void {
        this.dialogRef.close(null);
    }

    onSubmit(formValues: any): void {
        this.roleEditorForm.markAllAsTouched();

        if (this.roleEditorForm.valid) {
            const today = this.toolsService.toISOLocal(new Date());

            // this.role.roleId = formValues.RoleId;
            this.role.roleName = formValues.RoleName;

            this.dialogRef.close(this.role);
            this.roleEditorForm.reset();
        }
    }
}

/* Validation function to see if the inputted SAPID already exists. If so, the field will become invalid.
 * This error will NOT occurr if, while editing an existing SAPID, the user reverts changes to match the
 * original name provide to the form prior to saving.
 */
function isRoleTaken(name: string, rolesNames: string[]): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
        const isRoleTaken = rolesNames.some((value) => value === control.value);
        const error = isRoleTaken && control.dirty && control.value !== name ? { isRoleTaken: true } : null;
        return error;
    };
}
